module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"rate":"Поставьте балл","rateWarning":"Нужно поставить балл","review":"Ваш отзыв","placeholder":"Что вам понравилось или не понравилось в нашем сервисе?","send":"Отправить","thanks":"Спасибо за ваш отзыв!"}}')
  delete Component.options._Ctor
}
